import { setCrmActivityOwners } from 'store/models/crmActivity';

export default (newOwnerId) => {
    return (dispatch, getState) => {
        const { owners, listOwners } = getState().crmActivity;
        const newOwner = listOwners.filter(({ id }) => newOwnerId === id).shift();
        const newOwners = [...owners];
        newOwners.push(newOwner);
        dispatch(setCrmActivityOwners(newOwners));
    };
};
